(function () {
  'use strict';
  const cfgEl = document.getElementById('tpb-config');
  if (!cfgEl) return;
  let CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[tpb] bad #tpb-config', e); return; }
  const M = window.TitlePageModel, Kit = window.PhotoCropKit, SETUP = (CFG && CFG.setup) || {};
  if (!M || !Kit) { console.error('[tpb] TitlePageModel or PhotoCropKit is missing'); return; }
  if (SETUP.v !== 1 || !SETUP.enabled) return;

  const LAYOUTS = M.layoutKeys(), TRIM = [792, 612];
  const FONT_URLS = CFG.font_urls || {};
  const FONTS = (SETUP.fonts || []).filter(id => M.fontIds().includes(id) && FONT_URLS[id]);
  const HEX = /^#[0-9a-f]{6}$/i;
  const PAIRS = (SETUP.pairs || []).filter(p => p && p.id && HEX.test(p.page) && HEX.test(p.text));
  if (!FONTS.length || !PAIRS.length) { console.error('[tpb] no usable fonts or colour pairs'); return; }
  const EDGE = CFG.edge || '/apps/personalize';
  const VARIANTS = (CFG.variant_ids || []).map(String);
  const PROOF_W = 1200;

  const COPY = {
    launch: 'Personalize your title page', launchH: 'Personalize and add to cart',
    launchSub: 'Add your photos and a message, or skip it. It\'s free.',
    steps: ['Layout', 'Photo', 'Message', 'Colors & font', 'Review', 'Confirm'], photosStep: 'Photos', colorStep: 'Color',
    heads: ['Choose a layout', 'Add your photo', 'Write your message', 'Choose colors and a font', 'Check your page', 'Add your copy to the cart'],
    photosHead: 'Add your photos', colorHead: 'Choose a page color',
    skip: 'Skip', skipIntro: "Your copy comes without a personal page. It's still part of the numbered limited edition.",
    stepOf: 'Step {i} of {n}',
    layoutIntro: 'Choose how your photos and message sit on the page. You can come back and change it.',
    layoutGroup: 'Layout',
    photoIntro: {
      classic: 'It goes in the frame near the top of the page. A clear, well-lit photo prints best.',
      side_by_side: 'Your photos go side by side in the two frames. Clear, well-lit photos print best.',
      feature: 'Your first photo fills the tall frame and the next two go in the smaller frames beside it. Clear, well-lit photos print best.',
      full_page: 'It fills the page right to the edges, with your message on a band below. A large, sharp photo prints best.',
      photo_only: 'It fills the whole page, right to the edges. A large, sharp photo prints best.',
      more: 'Add a photo for each of the frames. Clear, well-lit photos print best.',
    },
    slot: 'Photo {i}',
    choose: 'Choose a photo', chooseSub: "You'll crop it to fit the frame next.",
    recrop: 'Adjust the crop', another: 'Choose another',
    soft: 'This photo may print a little soft at this size.', softMore: 'You can still use it, or choose a larger copy of the photo.',
    needPhoto: 'Add a photo to continue.', needPhotos: 'Add a photo to each frame to continue.',
    small: 'This photo is too small to print. Try a larger one.',
    needLarger: 'Choose a larger photo to continue.', needLargerAt: 'Photo {i} is too small to print. Choose a larger one to continue.',
    badPhoto: "We couldn't open that photo. Please choose a JPEG or PNG.",
    msgIntro: {
      classic: 'It goes below the frame, and the words get smaller to fit as you type.',
      full_page: 'It goes on the band at the bottom of the page, and the words get smaller to fit as you type.',
      message_only: 'It sits in the middle of the page, and the words get smaller to fit as you type.',
      more: 'It goes below the frames, and the words get smaller to fit as you type.',
    },
    msgLabel: 'Your message', placeholder: 'Type your custom message here',
    empty: 'Please type your message.', tooLong: 'Your message can be up to {n} characters.',
    chars: "This font can't print {chars}. Try removing it or choosing another font.",
    noFit: "That's more than fits on the page. Try a shorter message.",
    styleIntro: 'Each color pair is a page color with a text color chosen to read well on it.',
    styleIntroPhoto: 'Choose the color of the plain page that follows your photo.',
    colors: 'Colors', font: 'Font',
    reviewIntro: "Here's your page in the book. Look it over closely. Your page can't be changed after you order.",
    labels: ['Your page', 'Numbered page', 'Pages 2–3'], coverLabel: 'Front cover', coverNote: 'Cover subject to change.',
    caps: ['Your page opens the book.', 'Every copy is individually numbered. Yours gets its number when you order.', "The book's own pages come next."],
    standin: ['The rest of the book', 'continues here.'],
    proof: ["I've checked my spelling. My page will print exactly as shown.", "I've checked my photo and spelling. My page will print exactly as shown.",
      "I've checked my photos and spelling. My page will print exactly as shown."],
    proofPhoto: "I've checked my photo. My page will print exactly as shown.",
    next: 'Next', add: 'Add to cart', adding: 'Adding…', larger: 'See your page larger', close: 'Close',
    yourPhoto: 'Your photo', yourMessage: 'Your message', yourPage: 'Your page',
    loading: 'Opening your saved page…',
    gone: "We couldn't open your saved page, so you're starting a new one.",
    photoAgain: "We couldn't load your photo again. Please add it once more.",
    photosAgain: "We couldn't load all of your photos again. Please add the missing ones once more.",
    fontFail: "We couldn't load this font. Check your connection and try again, or choose another font.",
    retry: 'Try again',
    cartFail: "We couldn't add your book to the cart. Please try again.",
    trouble: "We're having trouble right now. Please try again in a moment.",
    lineMissing: "We couldn't find this book in your cart. Open your cart and try again.",
    refit: 'Your page changed a little while the font loaded. Please check it again.',
  };
  const STEPS = ['layout', 'photo', 'message', 'style', 'review', 'skip'];
  const PHOTO = STEPS.indexOf('photo'), MESSAGE = STEPS.indexOf('message'), REVIEW = STEPS.indexOf('review'), SKIP = 'skip';

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const wait = ms => new Promise(r => setTimeout(r, ms));
  const pct = (v, of) => +(v / of * 100).toFixed(4) + '%';
  const ICON = {
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    camera: '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/>',
    check: '<path d="M20 6L9 17l-5-5"/>',
    warn: '<path d="M12 9v4M12 17h.01"/><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>',
    zoom: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3M11 8v6M8 11h6"/>',
    crop: '<path d="M6 2v14a2 2 0 0 0 2 2h14"/><path d="M18 22V8a2 2 0 0 0-2-2H2"/>',
  };
  const icon = (k, s) => `<svg class="tpb-ic" width="${s || 16}" height="${s || 16}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICON[k]}</svg>`;

  const apiError = (status, body) => Object.assign(new Error((body && body.message) || 'request failed: ' + status), { status, code: (body && body.error) || null, body });
  const ProxyAPI = {
    async _json(r) {
      let body = null;
      try { body = await r.json(); } catch (e) {  }
      if (!r.ok) throw apiError(r.status, body);
      return body;
    },
    async approve(fields) {
      const fd = new FormData();
      Object.keys(fields).forEach(k => (fields[k] instanceof Blob ? fd.append(k, fields[k], k + '.jpg') : fd.append(k, fields[k])));
      return this._json(await fetch(EDGE + '/title-pages', { method: 'POST', body: fd, credentials: 'same-origin' }));
    },
    async get(id) { return this._json(await fetch(EDGE + '/title-pages/' + encodeURIComponent(id), { credentials: 'same-origin' })); },
  };
  const DemoAPI = {
    async approve(f) {
      await wait(700);
      const id = 'tp_demo' + Math.random().toString(36).slice(2, 14), pair = PAIRS.find(p => p.id === f.pair_id);
      return { id, image_url: '', cart_properties: { 'Title page': 'Personalized', Layout: M.layoutLabel(f.layout), Message: f.message, Font: M.fontName(f.font),
        Colors: pair ? pair.name : '', '_personalized-file-id': id, '_title_page_image': '' } };
    },
    async get() { await wait(300); throw apiError(404, { error: 'not_found' }); },
  };
  const API = CFG.demo === true ? DemoAPI : ProxyAPI;
  const withTimeout = (p, ms) => Promise.race([p, wait(ms).then(() => { throw new Error('timed out'); })]);

  function productForm() {
    const forms = $$('form[action*="/cart/add"]').filter(f => f.querySelector('[type=submit]'));
    if (!VARIANTS.length) return forms[0] || null;
    return forms.find(f => { const id = f.querySelector('[name=id]'); return id && VARIANTS.includes(String(id.value)); }) || null;
  }
  const pdpState = () => ($('[data-bk-pdp]') && window.bookPdp && window.bookPdp.state ? window.bookPdp.state() : null);
  function variantId() {
    const known = v => v && (!VARIANTS.length || VARIANTS.includes(String(v))) ? String(v) : null;
    const s = pdpState(), f = productForm(), idEl = f && f.querySelector('[name=id]');
    const pdp = $('[data-bk-pdp][data-bk-variant]');
    return known(s && s.variantId) || known(pdp && pdp.getAttribute('data-bk-variant')) || known(idEl && idEl.value) ||
      known(new URLSearchParams(location.search).get('variant')) || String(CFG.variant_id);
  }
  function quantity() {
    const s = pdpState(), f = productForm(), q = f && f.querySelector('[name=quantity]');
    let n = s ? +s.quantity : NaN;
    if (!(n > 0) && q) n = parseInt(q.value, 10);
    return n > 0 && n <= 99 ? n : 1;
  }
  async function cartPost(path, body) {
    const r = await fetch(path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (r.ok) return r.json().catch(() => ({}));
    let b = null; try { b = await r.json(); } catch (e) {  }
    throw Object.assign(new Error('cart ' + r.status), { cart: true, description: b && (b.description || b.message) });
  }
  async function editLine() {
    let cart = null;
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (r.ok) cart = await r.json();
    } catch (e) { cart = null; }
    const items = (cart && cart.items) || [], ids = [st.edit.id, st.edit.current].filter(Boolean);
    const line = items.find(i => st.edit.line && i.key === st.edit.line) ||
      items.find(i => i.properties && ids.includes(i.properties['_personalized-file-id']));
    if (!line) throw Object.assign(new Error('cart line not found'), { mine: COPY.lineMissing });
    return line;
  }

  const fam = id => 'tpb-' + id;
  (function addFontFaces() {
    const s = document.createElement('style'); s.id = 'tpb-fonts';
    s.textContent = FONTS.map(id => `@font-face{font-family:"${fam(id)}";src:url("${String(FONT_URLS[id]).replace(/"/g, '%22')}") format("woff2");font-weight:400;font-style:normal;font-display:block}`).join('\n');
    document.head.appendChild(s);
  })();
  const fontLoads = {}, fontOk = {}, fontFailed = {}, FONT_WAIT = 8000;
  function loadFont(id) {
    return fontLoads[id] || (fontLoads[id] = withTimeout(document.fonts.load(`100px "${fam(id)}"`), FONT_WAIT)
      .then(faces => (faces || []).length > 0 && faces.every(f => f.status === 'loaded'), () => false)
      .then(ok => {
        if (ok) { widths.clear(); fontOk[id] = true; delete fontFailed[id]; } else { delete fontLoads[id]; fontFailed[id] = true; }
        return ok;
      }));
  }
  function retryFont() {
    const id = st.font;
    delete fontFailed[id]; render();
    return loadFont(id).then(ok => { if (ok) refitChecked(); render(); return ok; });
  }
  const autoRetried = {};
  const widths = new Map(), mctx = document.createElement('canvas').getContext('2d');
  const measure = fontId => (text, sizePt) => {
    const k = fontId + '\n' + text;
    if (!widths.has(k)) { mctx.font = `100px "${fam(fontId)}"`; widths.set(k, mctx.measureText(text).width); }
    return widths.get(k) * sizePt / 100;
  };

  const st = {
    step: 0, reached: 0, layout: 'classic', skip: false, photos: [null], pool: [], pick: null, message: '', pair: PAIRS[0].id, font: FONTS[0],
    fit: { sizePt: M.layout('classic').message.size_pt.max, lines: [], fits: true }, proof: false, busy: false, done: false,
    tried: {}, error: '', alert: '', notice: '', loading: false, approved: null, edit: null,
  };
  const pair = () => PAIRS.find(p => p.id === st.pair) || PAIRS[0];
  const lay = () => M.layout(st.layout), mf = () => lay().message, frames = () => (st.skip ? [] : lay().photos);
  const many = () => frames().length > 1, msgOn = () => !st.skip && M.hasMessage(st.layout);
  const shownLayout = () => (st.skip ? SKIP : st.layout), tiles = () => (st.edit ? LAYOUTS : LAYOUTS.concat(SKIP));
  const on = i => {
    const s = STEPS[i];
    if (st.skip) return s === 'layout' || s === SKIP;
    return s === 'photo' ? frames().length > 0 : s === 'message' ? msgOn() : s !== SKIP;
  };
  const active = () => STEPS.filter((s, i) => on(i));
  const firstEmpty = () => st.photos.findIndex(p => !p);
  const slotAspect = i => M.photoAspect(st.layout, i);
  const akey = a => a.toFixed(5);
  const exactCrop = (p, i) => (p ? p.crops[akey(slotAspect(i))] || null : null);
  const cropOf = (p, i) => (p ? exactCrop(p, i) || p.crops[akey(p.aspect)] : null);
  function photoEntry(source, box, aspect, c) {
    return { source, box, aspect, making: {}, crops: { [akey(aspect)]: { box, blob: c.blob, w: c.w, h: c.h, url: URL.createObjectURL(c.blob) } } };
  }
  const tooSmall = (p, i) => { const c = cropOf(p, i); return !!c && M.photoTooSmall(c); };
  const forget = p => Object.values(p.crops).forEach(c => URL.revokeObjectURL(c.url));
  function ensure(p, aspect) {
    const key = akey(aspect);
    if (p.crops[key]) return Promise.resolve(p.crops[key]);
    if (p.making[key]) return p.making[key];
    const job = (async () => {
      const im = await Kit.decodeImage(p.source);
      try {
        const b = Kit.fitAspect(p.box, im.w, im.h, aspect);
        const sx = Math.round(b[0] * im.w), sy = Math.round(b[1] * im.h);
        const sw = Math.max(1, Math.round((b[2] - b[0]) * im.w)), sh = Math.max(1, Math.round((b[3] - b[1]) * im.h));
        const out = await Kit.toJpeg(im.src, sx, sy, sw, sh, 3600, 0.9);
        return (p.crops[key] = { box: b, blob: out.blob, w: out.w, h: out.h, url: URL.createObjectURL(out.blob) });
      } finally { im.close(); }
    })();
    const settle = () => { if (p.making[key] === job) delete p.making[key]; };
    job.then(settle, settle);
    return (p.making[key] = job);
  }
  async function ensureAll() {
    const out = [];
    for (let i = 0; i < st.photos.length; i++) out.push(await ensure(st.photos[i], slotAspect(i)));
    return out;
  }
  let fitting = Promise.resolve();
  function fitPhotos() {
    fitting = fitting.then(async () => {
      for (let i = 0; i < st.photos.length; i++) {
        const p = st.photos[i];
        if (!p || exactCrop(p, i)) continue;
        try { await ensure(p, slotAspect(i)); render(); } catch (e) { console.warn('[tpb] a photo could not be fitted to its frame', e); }
      }
    });
  }
  function useLayout(key) {
    const all = st.photos.filter(Boolean).concat(st.pool), n = M.photoCount(key);
    st.layout = key;
    st.photos = Array.from({ length: n }, (_, i) => all[i] || null);
    st.pool = all.slice(n);
  }
  function setLayout(key) {
    if (key === shownLayout() || !tiles().includes(key) || st.busy || st.loading) return;
    st.skip = key === SKIP;
    if (!st.skip) useLayout(key);
    changed(); refit(); st.error = '';
    render();
    if (!st.skip) fitPhotos();
  }
  const refit = () => { st.fit = M.fitMessage(st.message, st.layout, measure(st.font)); };
  const changed = () => { st.approved = null; st.proof = false; };
  const fitKey = () => JSON.stringify([st.fit.lines, st.fit.sizePt]);
  function refitChecked() {
    const before = fitKey();
    refit();
    if (fitKey() !== before && (st.proof || st.approved)) { changed(); st.alert = COPY.refit; return false; }
    return true;
  }
  function messageProblem() {
    if (!msgOn()) return '';
    const v = M.validateMessage(st.message, st.font, st.layout);
    if (!v.ok) {
      if (v.error === 'empty') return COPY.empty;
      if (v.error === 'too_long') return COPY.tooLong.replace('{n}', mf().max_chars);
      return COPY.chars.replace('{chars}', v.chars.join(' '));
    }
    return st.fit.fits ? '' : COPY.noFit;
  }
  function problem(i) {
    const s = STEPS[i];
    if (s === 'photo') {
      if (!on(i)) return '';
      if (!st.photos.every(Boolean)) return many() ? COPY.needPhotos : COPY.needPhoto;
      const small = st.photos.findIndex(tooSmall);
      return small < 0 ? '' : many() ? COPY.needLargerAt.replace('{i}', small + 1) : COPY.needLarger;
    }
    if (s === 'message' || s === 'style') return messageProblem();
    return '';
  }

  const frame = f => `left:${pct(f.x, TRIM[0])};top:${pct(f.y, TRIM[1])};width:${pct(f.w, TRIM[0])};height:${pct(f.h, TRIM[1])}`;
  const pageShell = cls => `<div class="tpb-page${cls ? ' ' + cls : ''}"></div>`;
  const slotName = i => (many() ? COPY.slot.replace('{i}', i + 1) : COPY.yourPhoto);
  function layoutPic(key) {
    if (key === SKIP) return '<span class="tpb-blank"></span>';
    const L = M.layout(key), m = L.message, bars = !m ? 0 : L.photos.length ? 2 : 3, size = m && m.size_pt.max, top = m && M.messageTop(key, size, bars);
    const inTrim = f => { const x = Math.max(0, f.x), y = Math.max(0, f.y); return { x, y, w: Math.min(TRIM[0], f.x + f.w) - x, h: Math.min(TRIM[1], f.y + f.h) - y }; };
    return L.photos.map(f => `<i style="${frame(inTrim(f))}"></i>`).join('') + [0.78, 0.5, 0.64].slice(0, bars).map((k, i) => {
      const w = m.w * k, cy = top + (i + 0.5) * size * m.leading;
      return `<b style="left:${pct(m.x + (m.w - w) / 2, TRIM[0])};width:${pct(w, TRIM[0])};top:${pct(cy, TRIM[1])}"></b>`;
    }).join('');
  }
  function paint(page) {
    const p = pair(), m = mf(), key = shownLayout();
    page.style.setProperty('--tp-page', p.page); page.style.setProperty('--tp-text', p.text);
    if (page.dataset.layout !== key) {
      page.dataset.layout = key;
      page.classList.toggle('is-blank', st.skip);
      page.innerHTML = st.skip ? '<span class="tpb-blank"></span>' : frames().map((f, i) => `<div class="tpb-photo" data-slot="${i}" style="${frame(f)}"></div>`).join('') + (m ? '<div class="tpb-msg"></div>' : '');
    }
    $$('.tpb-photo', page).forEach(ph => {
      const i = +ph.dataset.slot, c = cropOf(st.photos[i], i), url = c ? c.url : '';
      if (ph.dataset.url !== url || !ph.firstChild) {
        ph.dataset.url = url;
        ph.classList.toggle('is-empty', !url);
        ph.innerHTML = url ? `<img src="${esc(url)}" alt="">` : `<span class="tpb-photo-ph">${icon('camera', 22)}<span>${esc(slotName(i))}</span></span>`;
      }
    });
    const msg = $('.tpb-msg', page);
    if (!msg) return;
    const lines = st.fit.lines, size = lines.length ? st.fit.sizePt : m.size_pt.max;
    msg.style.left = pct(m.x, TRIM[0]); msg.style.width = pct(m.w, TRIM[0]);
    msg.style.top = pct(M.messageTop(st.layout, size, Math.max(1, lines.length)), TRIM[1]);
    msg.dataset.size = String(size);
    msg.style.fontFamily = `"${fam(st.font)}", Georgia, serif`;
    msg.style.lineHeight = String(m.leading);
    msg.style.fontSize = `calc(${size} * var(--pt))`;
    const html = lines.length ? lines.map(l => `<div class="tpb-line">${esc(l)}</div>`).join('') : `<div class="tpb-hint">${esc(COPY.yourMessage)}</div>`;
    if (msg.dataset.html !== html) { msg.dataset.html = html; msg.innerHTML = html; }
  }

  async function renderProof() {
    const k = PROOF_W / TRIM[0], W = PROOF_W, H = Math.round(TRIM[1] * k), p = pair(), m = mf(), fs = frames();
    const c = document.createElement('canvas'); c.width = W; c.height = H;
    const x = c.getContext('2d');
    x.fillStyle = p.page; x.fillRect(0, 0, W, H);
    x.save(); x.beginPath(); x.rect(0, 0, W, H); x.clip();
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    for (let i = 0; i < fs.length; i++) {
      const f = fs[i], cr = await ensure(st.photos[i], slotAspect(i)), im = await Kit.decodeImage(cr.blob);
      try {
        const fa = f.w / f.h;
        let sx = 0, sy = 0, sw = im.w, sh = im.h;
        if (im.w / im.h > fa) { sw = im.h * fa; sx = (im.w - sw) / 2; } else { sh = im.w / fa; sy = (im.h - sh) / 2; }
        x.drawImage(im.src, sx, sy, sw, sh, f.x * k, f.y * k, f.w * k, f.h * k);
      } finally { im.close(); }
    }
    x.restore();
    if (!m) return new Promise((res, rej) => c.toBlob(b => (b ? res(b) : rej(new Error('toBlob failed'))), 'image/jpeg', 0.88));
    const size = st.fit.sizePt * k, lineH = size * m.leading, top0 = M.messageTop(st.layout, st.fit.sizePt, st.fit.lines.length) * k;
    x.fillStyle = p.text; x.textAlign = 'center'; x.textBaseline = 'alphabetic';
    x.font = `${size}px "${fam(st.font)}"`;
    const mt = x.measureText('Hg');
    const asc = mt.fontBoundingBoxAscent != null ? mt.fontBoundingBoxAscent : size * 0.8, desc = mt.fontBoundingBoxDescent != null ? mt.fontBoundingBoxDescent : size * 0.2;
    st.fit.lines.forEach((line, i) => {
      const top = top0 + i * lineH;
      x.fillText(line, (m.x + m.w / 2) * k, top + (lineH - (asc + desc)) / 2 + asc);
    });
    return new Promise((res, rej) => c.toBlob(b => (b ? res(b) : rej(new Error('toBlob failed'))), 'image/jpeg', 0.88));
  }

  const luminance = hex => {
    const c = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255).map(v => (v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  };
  let launch;
  function placeLauncher() {
    api.placements = (api.placements || 0) + 1;
    if (!launch) {
      launch = document.createElement('div'); launch.id = 'tpb-launch';
      const p0 = PAIRS[0], team = [p0.page, p0.text].sort((a, b) => luminance(a) - luminance(b))[0];
      if (luminance(team) < 0.18) launch.style.setProperty('--tpb-l-team', team);
      launch.innerHTML = `<button type="button" class="tpb-launch-btn"><span class="tpb-launch-page" style="--tp-page:${p0.page};--tp-text:${p0.text}" aria-hidden="true"><i></i><b></b><b></b></span><span class="tpb-launch-t"><span class="tpb-launch-h">${esc(COPY.launchH)}</span><span class="tpb-launch-sub">${esc(COPY.launchSub)}</span></span></button>`;
      launch.querySelector('button').addEventListener('click', () => open());
    }
    const bundle = $('[data-bk-pdp] [data-bk-bundle-link]'), row = $('[data-bk-pdp] .bk-buyrow');
    const after = row && (row.nextElementSibling && row.nextElementSibling.matches('[data-bk-error]') ? row.nextElementSibling : row);
    const f = productForm(), submit = f && f.querySelector('[type=submit]');
    const target = bundle || after || submit || $('[data-bk-add]');
    if (target) {
      launch.classList.toggle('is-pdp', !!(bundle || after)); document.documentElement.classList.toggle('tpb-one', !!(bundle || after));
      if (bundle) { if (bundle.previousElementSibling !== launch) bundle.insertAdjacentElement('beforebegin', launch); }
      else if (target.nextElementSibling !== launch) target.insertAdjacentElement('afterend', launch);
      launch.classList.remove('is-sticky'); document.documentElement.classList.remove('tpb-sticky');
    } else {
      if (launch.parentNode !== document.body) document.body.appendChild(launch);
      launch.classList.add('is-sticky'); document.documentElement.classList.add('tpb-sticky'); document.documentElement.classList.remove('tpb-one');
    }
    return !!target;
  }

  let root, lastFocus = null;
  const shortTitle = () => String(CFG.product_title || '').split(':')[0].replace(/\s+[-–—]\s+premium limited edition\s*$/i, '').trim();
  function build() {
    root = document.createElement('div');
    root.id = 'tpb';
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-labelledby', 'tpb-title');
    root.dataset.state = 'closed'; root.tabIndex = -1;
    root.innerHTML = `
      <header class="tpb-top"><div class="tpb-top-t"><b id="tpb-title">${esc(COPY.launch)}</b>${shortTitle() ? `<span>${esc(shortTitle())}</span>` : ''}</div>
        <button type="button" class="tpb-x" aria-label="${esc(COPY.close)}">${icon('close', 20)}</button></header>
      <div class="tpb-main">
        <section class="tpb-stage" aria-label="${esc(COPY.yourPage)}">
          <div class="tpb-hero">${pageShell('tpb-big')}<button type="button" class="tpb-zoom-btn" aria-label="${esc(COPY.larger)}">${icon('zoom', 18)}</button>
            <div class="tpb-loading" hidden><i class="tpb-spin"></i><span>${esc(COPY.loading)}</span></div></div>
          <div class="tpb-slot-stage"></div>
        </section>
        <section class="tpb-side">
          <div class="tpb-chips" role="group" aria-label="Steps">${STEPS.map((s, i) => `<button type="button" class="tpb-chip" data-step="${s}"><i class="tpb-ck"><b>${i + 1}</b>${icon('check', 13)}</i><span>${esc(COPY.steps[i])}</span></button>`).join('')}</div>
          <div class="tpb-panel">
            <p class="tpb-notice" role="status" hidden></p>
            <p class="tpb-stepno"></p>
            <h2 class="tpb-h"></h2>
            <div class="tpb-body"></div>
          </div>
          <div class="tpb-bar">
            <label class="tpb-check" hidden><input type="checkbox" id="tpb-proof"><i class="tpb-box">${icon('check', 15)}</i><span>${esc(COPY.proof)}</span></label>
            <p class="tpb-alert" role="alert" hidden></p>
            <button type="button" class="tpb-btn tpb-next">${esc(COPY.next)}</button>
            <button type="button" class="tpb-btn tpb-add" hidden disabled>${esc(COPY.add)}</button>
          </div>
        </section>
      </div>
      <input type="file" class="tpb-file" accept="image/*" hidden>
      <div class="tpb-zoom" role="dialog" aria-modal="true" aria-label="${esc(COPY.larger)}" data-state="closed" hidden>
        <button type="button" class="tpb-x tpb-zoom-x" aria-label="${esc(COPY.close)}">${icon('close', 20)}</button>
        <div class="tpb-zoom-in">${pageShell()}</div></div>`;
    document.body.appendChild(root);

    root.querySelector('.tpb-top .tpb-x').addEventListener('click', () => close());
    $$('.tpb-chip', root).forEach((c, i) => c.addEventListener('click', () => go(i)));
    $('.tpb-next', root).addEventListener('click', () => next());
    $('.tpb-add', root).addEventListener('click', () => addToCart());
    $('#tpb-proof', root).addEventListener('change', e => { st.proof = e.target.checked; renderBar(); });
    $('.tpb-file', root).addEventListener('change', e => {
      const f = e.target.files && e.target.files[0], slot = st.pick;
      e.target.value = ''; st.pick = null;
      if (f) pickPhoto(f, slot);
    });
    $('.tpb-zoom-btn', root).addEventListener('click', () => openZoom());
    $('.tpb-hero .tpb-page', root).addEventListener('click', e => {
      if (st.skip) return;
      if (STEPS[st.step] === 'photo') {
        const fr = e.target.closest('.tpb-photo'), i = fr && !st.photos[+fr.dataset.slot] ? +fr.dataset.slot : st.photos.some(Boolean) ? -1 : 0;
        if (i >= 0) { chooseFile(i); return; }
      }
      openZoom();
    });
    $('.tpb-zoom', root).addEventListener('click', () => closeZoom());
    root.addEventListener('dragover', e => { if (e.dataTransfer && [...e.dataTransfer.types].includes('Files')) { e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; } });
    root.addEventListener('drop', e => {
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (!f) return;
      e.preventDefault();
      if (!frames().length || st.busy || st.loading) return;
      st.reached = Math.max(st.reached, PHOTO); go(PHOTO); pickPhoto(f, firstEmpty());
    });
  }
  const isOpen = () => !!root && root.classList.contains('open');

  function open() {
    if (!root) build();
    if (isOpen()) return;
    lastFocus = document.activeElement;
    root.classList.add('open'); root.dataset.state = 'open';
    document.documentElement.classList.add('tpb-open');
    FONTS.forEach(id => loadFont(id).then(ok => { if (ok && isOpen()) { refitChecked(); render(); } }));
    measureCover(); cutCover();
    refit(); render();
    root.focus({ preventScroll: true });
  }
  function close() {
    if (!isOpen() || st.busy) return;
    closeZoom();
    root.classList.remove('open'); root.dataset.state = 'closed';
    document.documentElement.classList.remove('tpb-open');
    const back = launch && launch.querySelector('button');
    const to = lastFocus && lastFocus.isConnected ? lastFocus : back;
    if (to && to.focus) to.focus({ preventScroll: true });
  }

  function go(i) {
    if (st.busy || st.loading || !on(i)) return;
    if (i > st.reached && STEPS[i] !== SKIP) return;
    for (let j = 0; j < i; j++) if (on(j) && problem(j)) { show(j, true); return; }
    show(i, false);
  }
  function show(i, flag) {
    if (st.step !== i) { st.alert = ''; }
    st.step = i;
    if (flag) st.tried[STEPS[i]] = true;
    st.error = flag ? problem(i) : '';
    render();
    const panel = $('.tpb-panel', root); if (panel) panel.scrollTop = 0;
  }
  function next() {
    st.tried[STEPS[st.step]] = true;
    const p = problem(st.step);
    if (p) { st.error = p; render(); return; }
    let j = st.step + 1;
    while (j < STEPS.length - 1 && !on(j)) j++;
    if (STEPS[j] !== SKIP) st.reached = Math.max(st.reached, j);
    show(j, false);
  }

  function renderBody() {
    const body = $('.tpb-body', root), step = STEPS[st.step], key = step === 'layout' ? step + ':' + tiles().length : step + ':' + shownLayout();
    if (body.dataset.step === key) return updateBody();
    body.dataset.step = key;
    if (step === 'layout') {
      body.innerHTML = `<p class="tpb-intro">${esc(COPY.layoutIntro)}</p>
        <div class="tpb-layouts" role="group" aria-label="${esc(COPY.layoutGroup)}">${tiles().map(k => `<button type="button" class="tpb-layout" data-layout="${esc(k)}" aria-pressed="false"><span class="tpb-lay-pic${k === SKIP ? ' is-blank' : ''}" aria-hidden="true">${layoutPic(k)}</span><span class="tpb-lay-name">${esc(k === SKIP ? COPY.skip : M.layoutLabel(k))}</span></button>`).join('')}</div>`;
      $$('.tpb-layout', body).forEach(b => b.addEventListener('click', () => setLayout(b.dataset.layout)));
    } else if (step === 'photo') {
      const fs = frames(), multi = fs.length > 1;
      body.innerHTML = `<p class="tpb-intro">${esc(COPY.photoIntro[st.layout] || COPY.photoIntro.more)}</p>
        <div class="tpb-slots${multi ? ' is-multi' : ''}">${fs.map((f, i) => `<div class="tpb-slot" data-slot="${i}">${multi ? `<p class="tpb-slot-h">${esc(slotName(i))}</p>` : ''}
          <div class="tpb-drop">${icon('camera', multi ? 20 : 24)}<button type="button" class="tpb-drop-btn">${esc(COPY.choose)}</button><span>${esc(COPY.chooseSub)}</span></div>
          <div class="tpb-have"><button type="button" class="tpb-ghost tpb-recrop">${icon('crop', 15)}<span>${esc(COPY.recrop)}</span></button><button type="button" class="tpb-ghost tpb-another">${icon('camera', 15)}<span>${esc(COPY.another)}</span></button></div>
          <p class="tpb-photo-warn" hidden>${icon('warn', 16)}<span><b>${esc(COPY.soft)}</b> ${esc(COPY.softMore)}</span></p>
          <p class="tpb-photo-small" hidden>${icon('warn', 16)}<span>${esc(COPY.small)}</span></p></div>`).join('')}</div>
        <p class="tpb-err" role="alert" hidden></p>`;
      $$('.tpb-slot', body).forEach(sl => {
        const i = +sl.dataset.slot;
        $('.tpb-drop', sl).addEventListener('click', () => chooseFile(i));
        $('.tpb-another', sl).addEventListener('click', () => chooseFile(i));
        $('.tpb-recrop', sl).addEventListener('click', () => recrop(i));
      });
    } else if (step === 'message') {
      body.innerHTML = `<p class="tpb-intro">${esc(COPY.msgIntro[st.layout] || COPY.msgIntro.more)}</p>
        <label class="tpb-label" for="tpb-message">${esc(COPY.msgLabel)}</label>
        <textarea id="tpb-message" rows="3" placeholder="${esc(COPY.placeholder)}" enterkeyhint="done" autocapitalize="sentences" spellcheck="true"></textarea>
        <div class="tpb-under"><span class="tpb-count" aria-live="polite"></span></div>
        <p class="tpb-err" role="alert" hidden></p>`;
      const ta = $('#tpb-message', body);
      ta.value = st.message;
      ta.addEventListener('keydown', e => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (matchMedia('(pointer: coarse)').matches) ta.blur();
      });
      ta.addEventListener('input', () => {
        if (/[\r\n]/.test(ta.value)) { const at = ta.selectionStart; ta.value = ta.value.replace(/\r\n?|\n/g, ' '); ta.setSelectionRange(at, at); }
        st.message = ta.value; changed();
        refit(); st.error = liveMessageError(); render();
      });
    } else if (step === 'style') {
      const text = msgOn();
      body.innerHTML = `<p class="tpb-intro">${esc(text ? COPY.styleIntro : COPY.styleIntroPhoto)}</p>
        <div class="tpb-sub"><b>${esc(COPY.colors)}</b><span class="tpb-pairname"></span></div>
        <div class="tpb-pairs" role="group" aria-label="${esc(COPY.colors)}">${PAIRS.map(p => `<button type="button" class="tpb-pair" data-pair="${esc(p.id)}" aria-label="${esc(p.name)}" title="${esc(p.name)}" style="--tp-page:${p.page};--tp-text:${p.text}">${text ? '<span>Aa</span>' : ''}</button>`).join('')}</div>
        ${text ? `<div class="tpb-sub"><b>${esc(COPY.font)}</b></div>
        <div class="tpb-fonts" role="group" aria-label="${esc(COPY.font)}">${FONTS.map(id => `<button type="button" class="tpb-font" data-font="${esc(id)}"><span style="font-family:'${fam(id)}',Georgia,serif">${esc(M.fontName(id))}</span></button>`).join('')}</div>` : ''}
        <p class="tpb-err" role="alert" hidden></p>`;
      $$('.tpb-pair', body).forEach(b => b.addEventListener('click', () => { st.pair = b.dataset.pair; changed(); render(); }));
      $$('.tpb-font', body).forEach(b => b.addEventListener('click', () => {
        st.font = b.dataset.font; changed(); refit(); st.error = st.tried.style ? messageProblem() : liveMessageError(); render();
        loadFont(st.font).then(ok => { if (ok) refitChecked(); render(); });
      }));
    } else if (step === SKIP) {
      body.innerHTML = `<p class="tpb-intro">${esc(COPY.skipIntro)}</p>`;
    } else {
      const text = msgOn();
      body.innerHTML = `<p class="tpb-intro">${esc(COPY.reviewIntro)}</p>
        <div class="tpb-fontfail" role="alert" hidden><p>${esc(COPY.fontFail)}</p><button type="button" class="tpb-ghost tpb-retry">${esc(COPY.retry)}</button></div>
        ${text ? `<div class="tpb-echo"><span>${esc(COPY.yourMessage)}</span><p class="tpb-echo-text"></p></div>` : ''}
        <button type="button" class="tpb-ghost tpb-larger">${icon('zoom', 15)}<span>${esc(COPY.larger)}</span></button>`;
      $('.tpb-larger', body).addEventListener('click', () => openZoom());
      $('.tpb-retry', body).addEventListener('click', () => retryFont());
      if (text && fontFailed[st.font] && !autoRetried[st.font]) { autoRetried[st.font] = true; queueMicrotask(retryFont); }
    }
    updateBody();
  }
  function liveMessageError() {
    const p = messageProblem();
    return p === COPY.empty && !st.tried.message ? '' : p;
  }
  function updateBody() {
    const body = $('.tpb-body', root), step = STEPS[st.step];
    const err = $('.tpb-err', body);
    if (err) { err.textContent = st.error; err.hidden = !st.error; }
    if (step === 'layout') {
      const p = pair(), row = $('.tpb-layouts', body);
      row.style.setProperty('--tp-page', p.page); row.style.setProperty('--tp-text', p.text);
      $$('.tpb-layout', body).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.layout === shownLayout())));
    } else if (step === 'photo') {
      $$('.tpb-slot', body).forEach(sl => {
        const i = +sl.dataset.slot, p = st.photos[i], c = cropOf(p, i);
        $('.tpb-drop', sl).hidden = !!p;
        $('.tpb-have', sl).hidden = !p;
        const small = !!c && M.photoTooSmall(c);
        $('.tpb-photo-small', sl).hidden = !small;
        $('.tpb-photo-warn', sl).hidden = small || !(c && M.warnLowRes(M.ppiFor({ w: c.w, h: c.h }, st.layout, i), st.layout));
      });
    } else if (step === 'message') {
      const n = Array.from(M.cleanText(st.message)).length, max = mf().max_chars;
      const c = $('.tpb-count', body); c.textContent = `${n} / ${max}`; c.classList.toggle('over', n > max);
      $('#tpb-message', body).setAttribute('aria-invalid', st.error ? 'true' : 'false');
    } else if (step === 'style') {
      $('.tpb-pairname', body).textContent = pair().name;
      $$('.tpb-pair', body).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.pair === st.pair)));
      $$('.tpb-font', body).forEach(b => b.setAttribute('aria-pressed', String(b.dataset.font === st.font)));
    } else if (step === 'review') {
      const echo = $('.tpb-echo-text', body);
      if (echo) echo.textContent = M.cleanText(st.message);
      $('.tpb-fontfail', body).hidden = !(msgOn() && fontFailed[st.font] && !fontOk[st.font]);
    }
  }

  let spreads;
  function buildSpreads() {
    spreads = document.createElement('div');
    spreads.className = 'tpb-spreads-wrap';
    const num = SETUP.numbered_preview ? `<img class="tpb-numbered" src="${esc(SETUP.numbered_preview)}" alt="">` : '';
    const cap = i => `<figcaption class="tpb-cap"><b>${esc(COPY.labels[i])}</b><span>${esc(COPY.caps[i])}</span></figcaption>`;
    const cv = CFG.cover && CFG.cover.url ? CFG.cover : null;
    const coverSrc = typeof coverCut === 'string' ? coverCut : cv && cv.url, coverState = typeof coverCut === 'string' ? '' : coverCut === false ? ' is-raw' : ' is-cutting';
    const cover = cv ? `<figure class="tpb-coversheet"><div class="tpb-cover${coverState}"><img src="${esc(coverSrc)}" alt=""${+cv.w > 0 && +cv.h > 0 ? ` width="${+cv.w}" height="${+cv.h}"` : ''}></div>
        <figcaption class="tpb-cap"><b>${esc(COPY.coverLabel)}</b>${CFG.presale === true ? `<span>${esc(COPY.coverNote)}</span>` : ''}</figcaption></figure>` : '';
    spreads.innerHTML = `<div class="tpb-spreads" aria-label="${esc(COPY.heads[3])}">${cover}
        <figure class="tpb-spread"><div class="tpb-pages"><div class="tpb-leaf tpb-endpaper"></div><div class="tpb-leaf tpb-right">${pageShell()}</div></div>${cap(0)}</figure>
        <figure class="tpb-spread"><div class="tpb-pages"><div class="tpb-leaf tpb-backing"></div><div class="tpb-leaf tpb-right tpb-numpage">${num}</div></div>${cap(1)}</figure>
        <figure class="tpb-spread"><div class="tpb-pages"><div class="tpb-leaf tpb-standin"><p>${esc(COPY.standin[0])}</p></div><div class="tpb-leaf tpb-right tpb-standin"><p>${esc(COPY.standin[1])}</p></div></div>${cap(2)}</figure>
      </div>`;
    $('.tpb-spread .tpb-page', spreads).addEventListener('click', () => openZoom());
    placeCover();
  }

  let coverBox = null, coverMeasuring = false;
  const fraction = b => b && [b.x0, b.y0, b.x1, b.y1].every(v => typeof v === 'number' && v >= 0 && v <= 1) && b.x1 > b.x0 && b.y1 > b.y0 ? b : null;
  function measureCover() {
    const cv = CFG.cover;
    if (!cv || !cv.url || coverBox || coverMeasuring) return;
    const fit = cv.fit || {};
    coverBox = fraction(fit.ink) || fraction(fit.book);
    if (coverBox) return;
    coverMeasuring = true;
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const w = Math.min(400, img.naturalWidth), h = Math.round(img.naturalHeight * w / img.naturalWidth), c = document.createElement('canvas');
        c.width = w; c.height = h;
        const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, w, h);
        const d = x.getImageData(0, 0, w, h).data, cols = new Array(w).fill(0), rows = new Array(h).fill(0);
        for (let y = 0; y < h; y++) for (let i = 0; i < w; i++) {
          const k = (y * w + i) * 4;
          if (d[k + 3] >= 128 && 0.2126 * d[k] + 0.7152 * d[k + 1] + 0.0722 * d[k + 2] < 247) { cols[i]++; rows[y]++; }
        }
        const first = a => a.findIndex(n => n >= 2), last = a => a.length - 1 - [...a].reverse().findIndex(n => n >= 2);
        if (first(cols) >= 0 && first(rows) >= 0) coverBox = { x0: first(cols) / w, y0: first(rows) / h, x1: (last(cols) + 1) / w, y1: (last(rows) + 1) / h };
      } catch (e) {  }
      placeCover();
    };
    img.src = cv.measure_url || cv.url;
  }
  const COVER_GROUND = 200;
  let coverCut = null;
  function cutCover() {
    const cv = CFG.cover;
    if (!cv || !cv.url || coverCut !== null) return;
    coverCut = undefined;
    const done = url => {
      coverCut = url || false;
      const box = spreads && $('.tpb-cover', spreads);
      if (!box) return;
      if (url) box.firstElementChild.src = url;
      box.classList.remove('is-cutting'); box.classList.toggle('is-raw', !url);
    };
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onerror = () => done(null);
    img.onload = () => {
      try {
        const w = img.naturalWidth, h = img.naturalHeight, n = w * h, c = document.createElement('canvas');
        c.width = w; c.height = h;
        const x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0);
        const px = x.getImageData(0, 0, w, h), d = px.data, lum = new Uint8Array(n), ground = new Uint8Array(n), stack = new Int32Array(n);
        for (let i = 0; i < n; i++) lum[i] = 0.2126 * d[4 * i] + 0.7152 * d[4 * i + 1] + 0.0722 * d[4 * i + 2];
        let top = 0;
        const push = i => { if (!ground[i] && lum[i] >= COVER_GROUND) { ground[i] = 1; stack[top++] = i; } };
        for (let i = 0; i < w; i++) { push(i); push(n - w + i); }
        for (let y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
        while (top) {
          const i = stack[--top], col = i % w;
          if (col > 0) push(i - 1);
          if (col < w - 1) push(i + 1);
          if (i >= w) push(i - w);
          if (i < n - w) push(i + w);
        }
        for (let i = 0; i < n; i++) if (ground[i]) { d[4 * i] = d[4 * i + 1] = d[4 * i + 2] = 0; d[4 * i + 3] = 255 - lum[i]; }
        x.putImageData(px, 0, 0);
        c.toBlob(b => done(b ? URL.createObjectURL(b) : null), 'image/png');
      } catch (e) { done(null); }
    };
    img.src = cv.url;
  }
  function placeCover() {
    const box = spreads && $('.tpb-cover', spreads), b = coverBox;
    if (!box || !b || !(+CFG.cover.w > 0 && +CFG.cover.h > 0)) return;
    const pad = 0.015, x0 = Math.max(0, b.x0 - pad), y0 = Math.max(0, b.y0 - pad), x1 = Math.min(1, b.x1 + pad), y1 = Math.min(1, b.y1 + pad);
    box.classList.add('is-cropped');
    const bw = (x1 - x0) * CFG.cover.w, bh = (y1 - y0) * CFG.cover.h;
    box.style.aspectRatio = `${bw.toFixed(1)} / ${bh.toFixed(1)}`;
    box.style.setProperty('--tpb-cover-ar', (bw / bh).toFixed(4));
    const im = box.firstElementChild;
    im.style.width = `${(100 / (x1 - x0)).toFixed(3)}%`;
    im.style.left = `${(-100 * x0 / (x1 - x0)).toFixed(3)}%`;
    im.style.top = `${(-100 * y0 / (y1 - y0)).toFixed(3)}%`;
  }
  function paintSpreads() {
    const p = pair();
    spreads.style.setProperty('--tp-page', p.page); spreads.style.setProperty('--tp-text', p.text);
    paint($('.tpb-spread .tpb-page', spreads));
  }

  function renderStage() {
    const review = STEPS[st.step] === 'review';
    if (review && !spreads) buildSpreads();
    const slot = $('.tpb-slot-stage', root);
    if (spreads && review && spreads.parentNode !== slot) { slot.appendChild(spreads); $('.tpb-stage', root).scrollTop = 0; }
    if (spreads && !review && spreads.parentNode) spreads.remove();
    root.classList.toggle('is-spreads', review);
    if (spreads && review) paintSpreads();
    paint($('.tpb-hero .tpb-page', root));
    $('.tpb-loading', root).hidden = !st.loading;
  }
  function renderBar() {
    const review = STEPS[st.step] === 'review', fin = review || STEPS[st.step] === SKIP, act = active(), text = msgOn();
    $$('.tpb-chip', root).forEach((c, i) => {
      c.hidden = !on(i);
      const num = String(act.indexOf(STEPS[i]) + 1), label = STEPS[i] === 'photo' && many() ? COPY.photosStep : STEPS[i] === 'style' && !text ? COPY.colorStep : COPY.steps[i];
      const b = c.querySelector('.tpb-ck b'), sp = c.querySelector(':scope > span');
      if (b.textContent !== num) b.textContent = num;
      if (sp.textContent !== label) sp.textContent = label;
      c.disabled = (i > st.reached && STEPS[i] !== SKIP) || st.loading;
      c.classList.toggle('is-on', i === st.step);
      c.classList.toggle('is-done', i < st.reached && i !== st.step && !problem(i));
      if (i === st.step) c.setAttribute('aria-current', 'step'); else c.removeAttribute('aria-current');
    });
    const add = $('.tpb-add', root), nx = $('.tpb-next', root), chk = $('.tpb-check', root);
    nx.hidden = fin; add.hidden = !fin; chk.hidden = !review;
    nx.disabled = st.loading;
    nx.classList.toggle('is-waiting', !!problem(st.step) && !fin);
    const box = $('#tpb-proof', root), proofText = text ? COPY.proof[Math.min(2, frames().length)] : COPY.proofPhoto, ps = $('.tpb-check > span', root);
    if (ps.textContent !== proofText) ps.textContent = proofText;
    const fontWait = text && !fontOk[st.font];
    box.checked = st.proof; box.disabled = fontWait || st.busy || st.done;
    chk.classList.toggle('is-waiting', fontWait);
    add.disabled = (review && !st.proof) || st.busy || st.done;
    add.setAttribute('aria-busy', String(st.busy));
    add.classList.toggle('is-busy', st.busy || st.done);
    add.innerHTML = st.busy || st.done ? `<i class="tpb-spin"></i><span>${esc(COPY.adding)}</span>` : esc(COPY.add);
    const al = $('.tpb-alert', root); al.textContent = st.alert; al.hidden = !st.alert || !fin;
    $('.tpb-x', root).disabled = st.busy;
  }
  function render() {
    if (!root) return;
    root.dataset.step = STEPS[st.step];
    root.dataset.layout = shownLayout();
    root.style.setProperty('--tpb-face', `"${fam(st.font)}"`);
    const act = active();
    $('.tpb-stepno', root).textContent = COPY.stepOf.replace('{i}', act.indexOf(STEPS[st.step]) + 1).replace('{n}', act.length);
    $('.tpb-h', root).textContent = STEPS[st.step] === 'photo' && many() ? COPY.photosHead : STEPS[st.step] === 'style' && !msgOn() ? COPY.colorHead : COPY.heads[st.step];
    const n = $('.tpb-notice', root); n.textContent = st.notice; n.hidden = !st.notice;
    renderBody();
    renderStage();
    renderBar();
  }

  function chooseFile(i) { st.pick = i; $('.tpb-file', root).click(); }
  const cropOptions = (layout, i) => ({
    aspect: M.photoAspect(layout, i), faces: false,
    hint: px => (M.photoTooSmall(px) ? COPY.small : M.warnLowRes(M.ppiFor(px, layout, i), layout) ? COPY.soft : ''),
  });
  async function crop(source, box, slot) {
    const n = frames().length;
    if (st.busy || st.done || !n) return;
    const i = Number.isInteger(slot) && slot >= 0 && slot < n ? slot : Math.max(0, firstEmpty()), layout = st.layout, aspect = slotAspect(i);
    let res;
    try { res = await Kit.open(box ? { blob: source, box } : source, cropOptions(layout, i)); }
    catch (e) { console.warn('[tpb] photo could not be opened', e); st.error = COPY.badPhoto; render(); return; }
    if (!res || st.layout !== layout) return;
    const old = st.photos[i];
    st.photos[i] = photoEntry(source, res.box, aspect, res);
    if (old) forget(old);
    changed(); st.error = ''; st.notice = '';
    render();
  }
  const pickPhoto = (file, slot) => crop(file, null, slot);
  function recrop(i) {
    const p = st.photos[i];
    if (p) crop(p.source, (exactCrop(p, i) || p).box, i);
  }

  function openZoom() {
    const z = $('.tpb-zoom', root);
    paint($('.tpb-page', z));
    z.hidden = false; z.dataset.state = 'open';
  }
  function closeZoom() {
    const z = root && $('.tpb-zoom', root);
    if (!z || z.hidden) return false;
    z.hidden = true; z.dataset.state = 'closed';
    return true;
  }

  const sig = v => JSON.stringify([st.layout, st.pair, st.font, M.cleanText(st.message), st.photos.map((p, i) => { const c = exactCrop(p, i); return c ? c.url : null; }), v]);
  function failMessage(e) {
    if (e && e.cart) return e.description || COPY.cartFail;
    if (e && e.status && e.status < 500 && e.body && e.body.message) return e.body.message;
    return COPY.trouble;
  }
  async function skipToCart() {
    if (st.busy || st.done) return;
    st.busy = true; st.alert = ''; renderBar();
    try {
      await cartPost('/cart/add.js', { items: [{ id: +variantId(), quantity: quantity() }] });
      st.busy = false; st.done = true; renderBar();
      api.navigate('/cart');
    } catch (e) {
      console.warn('[tpb] add to cart failed', e);
      st.busy = false; st.alert = failMessage(e); render();
    }
  }
  async function addToCart() {
    if (st.skip) return skipToCart();
    if (st.busy || st.done || !st.proof) return;
    st.busy = true; st.alert = ''; renderBar();
    try {
      for (let j = 0; j < REVIEW; j++) if (on(j) && problem(j)) { st.busy = false; show(j, true); return; }
      const text = msgOn(), wasLoaded = !text || !!fontOk[st.font];
      if (text && !(await loadFont(st.font))) { st.busy = false; render(); return; }
      if (!refitChecked() || !wasLoaded) {
        if (st.proof) { changed(); st.alert = COPY.refit; }
        st.busy = false; render(); return;
      }
      render();
      if (messageProblem()) { st.busy = false; show(MESSAGE, true); return; }
      const crops = await ensureAll();
      if (crops.some(c => M.photoTooSmall(c))) { st.busy = false; show(PHOTO, true); return; }
      const line = st.edit ? await editLine() : null;
      const variant = line ? String(line.variant_id) : variantId();
      let res = st.approved && st.approved.sig === sig(variant) ? st.approved.res : null;
      if (!res) {
        const page = await renderProof();
        const fields = { product_id: String(CFG.product_id), variant_id: variant, layout: st.layout, pair_id: st.pair, font: st.font };
        if (text) Object.assign(fields, { message: M.cleanText(st.message), size_pt: String(st.fit.sizePt), lines: JSON.stringify(st.fit.lines) });
        crops.forEach((c, i) => { fields['photo' + (i + 1)] = c.blob; });
        res = await API.approve(Object.assign(fields, { page_jpg: page, proof_ok: '1' }));
        if (!res || !res.cart_properties) throw new Error('no cart properties');
        st.approved = { sig: sig(variant), res };
      }
      if (line) {
        const cart = await cartPost('/cart/change.js', { id: line.key, quantity: line.quantity, properties: res.cart_properties });
        const now = ((cart && cart.items) || []).find(i => i.properties && i.properties['_personalized-file-id'] === res.id);
        st.edit.current = res.id; st.edit.line = now ? now.key : null;
        forgetEditParams();
      } else await cartPost('/cart/add.js', { items: [{ id: +variant, quantity: quantity(), properties: res.cart_properties }] });
      st.busy = false; st.done = true; renderBar();
      api.navigate('/cart');
    } catch (e) {
      if (!(e && e.mine)) console.warn('[tpb] add to cart failed', e);
      st.busy = false; st.alert = (e && e.mine) || failMessage(e); render();
    }
  }

  function forgetEditParams() {
    try {
      const u = new URL(location.href);
      u.searchParams.delete('title_page'); u.searchParams.delete('line');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {  }
  }
  async function restore(id) {
    st.loading = true; render();
    let b = null;
    try {
      b = await API.get(id);
      if (!b || String(b.product_id) !== String(CFG.product_id)) b = null;
    } catch (e) { b = null; }
    if (!b) { st.loading = false; st.notice = COPY.gone; render(); return; }
    if (PAIRS.some(p => p.id === b.pair_id)) st.pair = b.pair_id;
    if (FONTS.includes(b.font)) st.font = b.font;
    useLayout(LAYOUTS.includes(b.layout) ? b.layout : 'classic');
    st.message = b.message || '';
    const urls = (Array.isArray(b.photo_urls) ? b.photo_urls : [b.photo_url]).slice(0, frames().length);
    let missed = false;
    await Promise.all(frames().map(async (f, i) => {
      try {
        if (!urls[i]) throw new Error('no photo for frame ' + (i + 1));
        const r = await fetch(urls[i], { credentials: 'omit' });
        if (!r.ok) throw new Error('photo ' + r.status);
        const blob = await r.blob(), im = await Kit.decodeImage(blob);
        const w = im.w, h = im.h; im.close();
        st.photos[i] = photoEntry(blob, [0, 0, 1, 1], slotAspect(i), { blob, w, h });
      } catch (e) { console.warn('[tpb] a saved photo could not be loaded', e); missed = true; }
    }));
    if (missed) st.notice = many() ? COPY.photosAgain : COPY.photoAgain;
    await loadFont(st.font);
    refit();
    st.loading = false;
    st.reached = REVIEW;
    const first = STEPS.slice(0, REVIEW).findIndex((s, j) => on(j) && problem(j));
    show(first === -1 ? REVIEW : first, first !== -1 && first !== PHOTO);
  }

  function previewBarOffset() {
    let ro;
    const set = () => {
      const w = document.getElementById('PBarNextFrameWrapper');
      let h = 0;
      if (w && getComputedStyle(w).display !== 'none') { const r = w.getBoundingClientRect(); h = r.height > 0 ? Math.max(0, Math.min(140, innerHeight - r.top)) : 0; }
      document.documentElement.style.setProperty('--tpb-pbar', h + 'px');
      if (w && !ro && window.ResizeObserver) { ro = new ResizeObserver(set); ro.observe(w); }
    };
    set(); [500, 1500, 3500, 7000].forEach(t => setTimeout(set, t)); addEventListener('resize', set);
  }

  const api = {
    open, close,
    navigate: url => { location.assign(url); },
  };
  window.TitlePageBuilder = api;

  function init() {
    document.documentElement.classList.add('tpb-on');
    placeLauncher();
    let queued = false;
    const ours = n => n.nodeType === 1 && (n.id === 'tpb' || n.id === 'tpb-launch' || n.classList.contains('pck'));
    const mine = m => (m.target.closest && m.target.closest('#tpb, .pck')) || [...m.addedNodes, ...m.removedNodes].every(ours);
    new MutationObserver(records => {
      if (queued || records.every(mine)) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; placeLauncher(); });
    }).observe(document.body, { childList: true, subtree: true });
    previewBarOffset();
    document.addEventListener('click', e => {
      const b = document.documentElement.classList.contains('tpb-one') && e.target.closest && e.target.closest('[data-bk-pdp] [data-bk-add]');
      if (!b || b.disabled) return;
      e.preventDefault(); e.stopImmediatePropagation();
      open();
    }, true);
    document.addEventListener('keydown', e => {
      if (!isOpen()) return;
      if (e.key === 'Escape') {
        if (e.defaultPrevented) return;
        e.preventDefault();
        if (!closeZoom()) close();
        return;
      }
      if (e.key === 'Tab' && !document.querySelector('.pck')) {
        const z = $('.tpb-zoom', root), scope = z.hidden ? root : z;
        const f = $$('button:not([disabled]), input:not([disabled]):not([type=file]), textarea, [tabindex="0"]', scope).filter(x => x.getClientRects().length && !x.closest('[hidden]'));
        if (!f.length) return;
        const i = f.indexOf(document.activeElement);
        if (i === -1 || (e.shiftKey && i === 0) || (!e.shiftKey && i === f.length - 1)) { e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); }
      }
    });
    addEventListener('pageshow', e => { if (e.persisted && root) { st.done = false; st.busy = false; renderBar(); } });
    const q = new URLSearchParams(location.search), id = q.get('title_page');
    if (id) { st.edit = { id, line: q.get('line') || null }; open(); restore(id); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
